import React from 'react';
import { withStyles } from '@material-ui/core';
import { withI18n } from 'react-i18next';
import { useParams } from 'react-router';
import EmailsContextProvider from '@/contexts/Emails/context';
import styles from './styles';
import TitanChangeCycleWrapper from './TitanChangeCycleWrapper';

const TitanChangeCycle = () => {
  const { domain } = useParams();

  return (
    <EmailsContextProvider>
      <TitanChangeCycleWrapper domain={domain} />
    </EmailsContextProvider>
  );
};

export default withI18n()(withStyles(styles)(TitanChangeCycle));
